import Car from '@/models/Car'
import User, { hasRole, Role } from '@/models/User'

export default class CarPolicy {
	viewAny(_user: User): boolean {
		return true
	}

	view(user: User, car: Car) {
		switch (user.role) {
			case Role.USER:
				return user.company?.id === car.entry.catalog.company.id
			case Role.AUDITOR:
				return user.auditor?.id === car.entry.catalog.auditor?.id
			default:
				return false
		}
	}

	create(user: User) {
		return hasRole(user, Role.USER)
	}

	update(user: User, car: Car) {
		return hasRole(user, Role.USER) && user.company?.id === car.entry.catalog.company.id
	}

	restore(user: User, car: Car) {
		return hasRole(user, Role.USER) && user.company?.id === car.entry.catalog.company.id
	}

	delete(user: User, car: Car) {
		return hasRole(user, Role.USER) && user.company?.id === car.entry.catalog.company.id
	}

	forceDelete(_user: User, _car: Car) {
		return false
	}
}
